import React, { useState, useCallback } from 'react';
import * as S from './style';
import { Row, Label, Btn } from 'components';
import { LABEL_CARINFO_COUNT } from 'commons/ZimssaString';

import { ReactComponent as Minus } from 'assets/img/common/ic_minus.svg';
import { ReactComponent as Plus } from 'assets/img/common/ic_plus.svg';

interface Props {
    carInfo: string;
    onClickHandler?: (count: string | number) => void;
}

function FormCarCounter({ carInfo, onClickHandler }: Props): React.ReactElement {
    const [count, setCount] = useState(1);
    const callbackIncrease = useCallback(() => {
        if (count <= 999) {
            setCount(count + 1);
            onClickHandler && onClickHandler(count + 1);
        }
    }, [count, onClickHandler]);

    const callbackDecrease = useCallback(() => {
        if (count !== 1) {
            setCount(count - 1);
            onClickHandler && onClickHandler(count + 1);
        }
    }, [count, onClickHandler]);

    return (
        <Row>
            <S.CarCounterContainer>
                <S.CarCounterWrapper>
                    <Label contents={LABEL_CARINFO_COUNT} fontStyle={'body2'} color={'gray_opacity_800'} />
                    <Label contents={`${carInfo}`} fontStyle={'subtitle'} color={'gray_opacity_400'} />
                </S.CarCounterWrapper>
                <S.CountWrapper>
                    <S.CountBtnWrapper>
                        <Btn onClick={callbackDecrease} backGroundColor={'transparent'}>
                            <Minus />
                        </Btn>
                    </S.CountBtnWrapper>
                    <Label contents={`${count}대`} fontStyle={'body2'} color={'gray_opacity_800'} />
                    <S.CountBtnWrapper>
                        <Btn onClick={callbackIncrease} backGroundColor={'transparent'}>
                            <Plus />
                        </Btn>
                    </S.CountBtnWrapper>
                </S.CountWrapper>
            </S.CarCounterContainer>
        </Row>
    );
}

export default FormCarCounter;
